import { useBexApi } from '@shared-ui/bex-api-context';
import React from 'react';
import useNavigationParams from '../../hooks/useNavigationParams';
import { useHeaderQuery } from '../../graphql/__generated__/types';
import { Helmet } from 'react-helmet-async';

interface HeaderTitleProps {
  documentTitle?: string;
  content?: string;
}
const HeaderTitle: React.FC<HeaderTitleProps> = ({ documentTitle, content }) => {
  const { context } = useBexApi();
  const { hubId } = useNavigationParams();

  const { data, error, loading } = useHeaderQuery({ variables: { context, hubId } });

  if (!data || loading || error) {
    return null;
  }

  const { hubName } = data.documentation.header;

  return (
    <Helmet>
      <title>{documentTitle ? `${documentTitle} - Expedia Group ${hubName}` : `Expedia Group ${hubName}`}</title>
      <meta name="description" content={content ? content : hubName} />
    </Helmet>
  );
};

export default HeaderTitle;
